import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  sourceType() {
    const options = ['product', 'download', 'external_promoter'];

    return faker.helpers.arrayElement(options);
  },

  articleNumber() {
    return faker.random.alphaNumeric(8).toUpperCase();
  },

  headline() {
    return faker.commerce.productName();
  },

  artist() {
    return faker.name.fullName();
  },

  articleImageUrl() {
    return faker.image.imageUrl();
  },

  voucherUrl() {
    return faker.internet.url();
  },

  campaign() {
    return faker.commerce.department();
  },

  releaseDate() {
    return faker.date.past();
  },

  validityPeriod() {
    return '30 days';
  },

  watermark: false,

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
